import { TextFrame } from 'data/TextFrame';
import { TextStyleUpdate } from 'data/TextStyleUpdate';
import { editedText } from 'state/actions';
import { getFrameById } from 'state/FlyerState';
import RootState from 'state/RootState';
import { Command, CommandFunction } from './Command';

const updateStyles = (
  frame: TextFrame,
  propertyName: string,
  values: TextStyleUpdate,
  updateThumbnail: boolean,
  dispatch: Function
) => {
  const keys = Object.keys(values);
  keys.forEach(k => {
    frame.textStyle[k] = values[k];
  });
  frame.didChangeStyle(propertyName);
  dispatch(editedText(frame));
  if (updateThumbnail) {
    frame.updateThumbnail();
  }
};

export class ChangeTextStylesCommand extends Command {
  frameId: string;
  values: TextStyleUpdate;
  prevValues: TextStyleUpdate;
  propertyName: string;
  constructor(frameId: string, propertyName: string, values: TextStyleUpdate) {
    super();
    this.frameId = frameId;
    this.propertyName = propertyName;
    this.values = values;
    this.canMerge = true;
  }
  execute(firstTime?: boolean | undefined): CommandFunction {
    return (dispatch: Function, getState: () => RootState) => {
      const frame = getFrameById(getState().flyer, this.frameId);
      if (frame && frame instanceof TextFrame) {
        if (firstTime) {
          const keys = Object.keys(this.values);
          this.prevValues = {};
          keys.forEach(k => {
            this.prevValues[k] = frame.textStyle[k];
          });
        }
        updateStyles(
          frame,
          this.propertyName,
          this.values,
          !firstTime,
          dispatch
        );
      }
    };
  }
  undo(): CommandFunction {
    return (dispatch: Function, getState: () => RootState) => {
      const frame = getFrameById(getState().flyer, this.frameId);
      if (frame && frame instanceof TextFrame) {
        updateStyles(frame, this.propertyName, this.prevValues, true, dispatch);
      }
    };
  }
  merge(nextCommand: Command): void {
    if (nextCommand instanceof ChangeTextStylesCommand) {
      if (this.propertyName === nextCommand.propertyName) {
        this.values = nextCommand.values;
      } else {
        throw new Error(`Cannot merge because it's a different property`);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/state/commands/ChangeTextStylesCommand.ts